import { c as _c } from "react/compiler-runtime";
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link as ReachLink } from 'react-router-dom';
import Button from 'shared/button';
import EmptyState from 'shared/empty-state';
import { Box, BoxProps, Flex } from 'shared/grid';
import IconWrapper from 'shared/icon-wrapper';
import { Heading } from 'shared/typography';
import { useLocationId } from '../hooks';
export const BorderBox = t0 => {
  const $ = _c(7);
  let children;
  let rest;
  if ($[0] !== t0) {
    ({
      children,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = rest;
  } else {
    children = $[1];
    rest = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["background", "borderColor"];
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== children || $[5] !== rest) {
    t2 = <Box bg="background" borderRadius={2} borderWidth="1px" borderStyle="solid" borderColor={t1} p={6} {...rest}>{children}</Box>;
    $[4] = children;
    $[5] = rest;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export const BookStepHeading = t0 => {
  const $ = _c(8);
  const {
    children,
    backTo
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      gap: 4
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== backTo) {
    t2 = <IconWrapper flexShrink={0} as={ReachLink} to={backTo} icon={faArrowLeft} size={1} />;
    $[1] = backTo;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children) {
    t3 = <Heading fontSize={3}>{children}</Heading>;
    $[3] = children;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <Flex alignItems="center" sx={t1}>{t2}{t3}</Flex>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
type BusinessOfflineStateProps = {
  heading?: string;
  subheading?: string;
};
export const BusinessOfflineState: React.FC<BusinessOfflineStateProps> = t0 => {
  const $ = _c(11);
  const {
    heading,
    subheading
  } = t0;
  const [locationId] = useLocationId();
  let t1;
  if ($[0] !== heading) {
    t1 = heading ? heading : <FormattedMessage id="Public.ServicesView.notTakingBookings" defaultMessage="Unfortunately we are not currently taking online bookings." />;
    $[0] = heading;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== subheading) {
    t2 = subheading ? subheading : <FormattedMessage id="Public.ServicesView.notTakingBookingsSubheading" defaultMessage="Contact us to enquire about availability." />;
    $[2] = subheading;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = "/contact" + (locationId ? `?lid=${locationId}` : "");
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FormattedMessage id="Contact us" defaultMessage="Contact us" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <Button as={ReachLink} className="hide-for-small-only" mr={2} variant="outlined" color="gray" to={t3}>{t4}</Button>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t5) {
    t6 = <><EmptyState heading={t1} subheading={t2} callToAction={t5} /></>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};